var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 111,
    viewBox: "0 0 130 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7292 65.8874C1.32328 60.8138 1.31122 51.0972 7.70509 46.0096L7.7053 46.0099L59.2483 5.01086C65.6928 -0.113737 75.2146 4.42116 75.2935 12.6536L75.2935 12.6543L75.4043 23.7919L75.424 25.7715L77.4038 25.772L114.84 25.7799L114.841 25.7799C116.508 25.7798 118.159 26.1083 119.699 26.7465C121.239 27.3848 122.638 28.3203 123.817 29.4997C124.995 30.679 125.929 32.079 126.566 33.6196C127.203 35.1603 127.531 36.8114 127.529 38.4785L127.495 73.4596C127.495 73.4596 127.495 73.4597 127.495 73.4597C127.492 76.8225 126.154 80.0464 123.774 82.423C121.395 84.7996 118.17 86.1345 114.807 86.1343L114.807 86.1343L77.412 86.1363L75.4132 86.1364L75.4121 88.1352L75.4062 99.0135C75.4062 99.0135 75.4062 99.0135 75.4062 99.0136C75.4012 107.283 65.8565 111.896 59.3776 106.766L59.3773 106.766L7.72965 65.8878C7.7295 65.8876 7.72935 65.8875 7.7292 65.8874Z",
    fill: "#99D7FF",
    stroke: "#0098FC",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.230a32fa084230f9dbc282b76fed4892.svg";
export { ForwardRef as ReactComponent };